import _ from "lodash";

// The backend updates a user record based on whatever fields it receives in the PUT payload - it
// has no way to tell "the FE just resent everything" apart from "the FE means to touch every one
// of these fields", so a payload carrying the full user object (groups, views, account_status,
// etc., all unchanged) makes it do that much more work for nothing. This computes only the
// actually-changed fields, restricted to `editableKeys` (the fields a given form actually lets the
// user edit) - never the object's OTHER keys, even if they happen to differ (e.g. between two
// different snapshots of a Redux-derived draft), since those were never something this form could
// have changed in the first place.
export const getChangedFields = <T extends Record<string, any>>(
  original: T,
  updated: T,
  editableKeys: readonly (keyof T)[]
): Partial<T> => {
  const changed: Partial<T> = {};
  editableKeys.forEach((key) => {
    if (!_.isEqual(original[key], updated[key])) {
      changed[key] = updated[key];
    }
  });
  return changed;
};
